import React from "react";
import { useLanguage } from "../context/LanguageContext";
import LegalPage from "../components/LegalPage";

const Disclaimer = () => {
  const { t } = useLanguage();
  return <LegalPage data={t.disclaimerPage} />;
};

export default Disclaimer;
